/****************
 * WHAT A SCREEN CAN TELL THE ORB BEYOND ITS ADDRESS. 2026-10-04.
 *
 * The Orb is told which screen the person is on from the route alone
 * (OrbChat.tsx, screenFor). On the Strategy Builder that is "the Strategy
 * Builder" whatever step they are on, so "what do I put here?" could not be
 * answered about the step in front of them -- and the Orb's walk-through
 * (03-strategy-builder.md, "Walking someone through building one") is told to
 * name the step they are on.
 *
 * A screen sets one short English sentence while it is mounted and clears it
 * when it goes; OrbChat sends it in place of the route's name. English because
 * it is read by the model, beside knowledge written in English, never shown.
 ****************/

let detail = '';

export function setOrbScreenDetail(text: string): void {
    detail = text.trim();
}

export function orbScreenDetail(): string {
    return detail;
}
